<template>
	<div class="section-slider">
		<div class="loader" v-if="showLoader">
			<v-progress-circular
				:color="`theme${themeId}`"
				indeterminate
				:size="50"
			></v-progress-circular>
		</div>
		<div class="btn-customers">
			<v-tooltip top>
				<v-btn
					class="btn-auto btn-see-customers"
					color="accent"
					depressed
					slot="activator"
					@click="showGallery"
				>
					<img src="/static/images/icons/btn-customers.svg" alt="" height="30">
				</v-btn>
				<span>Mira nuestros clientes</span>
			</v-tooltip>
		</div>
		<slider
			animation="fade"
			:autoplay="false"
			class="section-slider-slides"
			height="100%"
			:indicators="false"
			:interval="5000"
			:speed="2000"
		>
			<slider-item
				class="section-slider-slides-item"
				v-for="slide in slides" :key="slide.id"
			>
				<v-layout
					row wrap class="section-slider-slide"
				>
					<v-flex xs12 class="section-slider-column">
						<div class="section-slide-container">
							<img
								src="/static/images/simulator/phone-case.png"
								alt="case"
								class="slide-case"
							/>
							<template v-if="slide.id === 1">
								<img
									v-if="logo"
									alt="logo"
									class="slide-logo"
									height="24"
									:src="logo"
								/>
								<img
									v-if="background"
									alt="fondo"
									class="slide-background"
									:src="background"
								/>
							</template>
							<img
								:alt="slide.alt"
								:class="slide.class"
								:src="slide.image"
							/>
						</div>
					</v-flex>
				</v-layout>
			</slider-item>
		</slider>
		<v-dialog
			content-class="dialog-gallery"
			v-model="dialog"
			persistent
			max-width="70%"
		>
			<v-card>
				<v-layout row wrap>
					<v-flex xs12>
						<div class="bar-title">
							Nuestros Clientes
							<v-btn
								class="btn-auto bar-title-btn"
								depressed
								icon
								@click="hiddenDialog"
							>
								<v-icon color="white">close</v-icon>
							</v-btn>
						</div>
					</v-flex>
				</v-layout>
				<v-layout row wrap>
					<v-flex xs12>
						<div class="section-slider section-gallery">
							<slider
								animation="fade"
								:autoplay="false"
								class="section-slider-slides"
								height="100%"
								indicators="left"
								:interval="5000"
								:speed="2000"
							>
								<slider-item
									class="section-slider-slides-item"
									v-for="(slide, index) in gallery" :key="index"
								>
									<v-layout
										row wrap class="section-slider-slide"
									>
										<v-flex xs12 class="section-slider-column">
											<img
												alt="cliente validado"
												:src="slide"
											/>
										</v-flex>
									</v-layout>
								</slider-item>
							</slider>
						</div>
					</v-flex>
				</v-layout>
			</v-card>
		</v-dialog>
	</div>
</template>
<script>
function hiddenDialog() {
	this.dialog = false;
}

function showGallery() {
	this.dialog = true;
}

function showLoader() {
	return this.loadingColor || this.loadingLogo || this.loadingBackground;
}

function themeId(value) {
	this.slides = this.slides.map((slide, index) => {
		const newSlide = { ...slide };
		newSlide.image = index === 0 ? `/static/images/themes/theme-${value}-1.png` :
			`/static/images/themes/theme-${value}-${index + 1}.jpg`;
		return newSlide;
	});
}

function data() {
	return {
		dialog: false,
		slides: [
			{
				id: 1,
				alt: 'simulador de aplicación',
				class: 'section-slider-slide-1',
				image: '/static/images/themes/theme-1-1.png',
			},
			{
				id: 2,
				alt: 'simulador de aplicación',
				class: 'section-slider-slide-2',
				image: '/static/images/themes/theme-1-2.jpg',
			},
			{
				id: 3,
				alt: 'simulador de aplicación',
				class: 'section-slider-slide-3',
				image: '/static/images/themes/theme-1-3.jpg',
			},
			{
				id: 4,
				alt: 'simulador de aplicación',
				class: 'section-slider-slide-4',
				image: '/static/images/themes/theme-1-4.jpg',
			},
		],
		gallery: [
			'/static/images/gallery/customer-1.png',
			'/static/images/gallery/customer-2.png',
			'/static/images/gallery/customer-3.png',
			'/static/images/gallery/customer-4.png',
		],
		swiperOptions: {
			spaceBetween: 30,
			centeredSlides: true,
			autoplay: {
				delay: 10500,
				disableOnInteraction: true,
			},
			pagination: false,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		},
	};
}

export default {
	name: 'section-phone',
	computed: {
		showLoader,
	},
	data,
	methods: {
		hiddenDialog,
		showGallery,
	},
	props: {
		background: String,
		colorSelect: {
			default: () => {},
			type: Object,
		},
		loadingBackground: {
			default: false,
			type: Boolean,
		},
		loadingColor: {
			default: false,
			type: Boolean,
		},
		loadingLogo: {
			default: false,
			type: Boolean,
		},
		logo: String,
		themeId: [Number, String],
	},
	watch: {
		themeId,
	},
};
</script>
<style lang="scss" scoped>
	.section-slider {
		align-items: center;
		background-color: color(background-simulator);
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.07);
		border-radius: 15px;
		display: flex;
		justify-content: center;
		height: 779px;
		margin: 24px auto 0px;
		padding: 36px 1% 48px;
		position: relative;
		width: 93%;

		@media (min-width: 936px) {
			height: 60%;
			margin: 0px;
			width: 100%;
		}

		&.section-gallery {
			padding: 0px;
			text-align: center;

			@media (min-width: 936px) {
				bottom: 0;
				height: 100%;
				margin: 35px 0px auto auto;
				right: 10%;
				top: 0;
				width: 50%;
			}
		}
	}

	.section-slider-slide {
		height: 100%;
	}

	.section-gallery {
		height: 670px;
		margin-top: 356px;
		width: 82%;

		.section-slider-slides {
			height: 965px !important;
			margin-bottom: 0px;
			margin-top: 0px;
			top: -178px;

			@media (min-width: 768px) {
				height: 810px !important;
				top: -98px;
			}

			@media (min-width: 936px) {
				height: 529px !important;
				top: 2px;
			}
		}

		@media (min-width: 768px) {
			margin-top: 190px;
		}

		@media (min-width: 936px) {
			margin-top: 0px;
		}

		.slider-item {
			top: 356px;

			@media (min-width: 768px) {
				top: 200px;
			}

			@media (min-width: 936px) {
				top: 0px;
			}
		}
	}

	.slide-case {
		height: 571px;
		position: relative;
		width: 274px;
		z-index: 1;

		@media (min-width: 936px) {
			height: 641px;
			width: 309px;
		}
	}

	.slide-logo,
	.slide-background,
	.section-slider-slide-1,
	.section-slider-slide-2,
	.section-slider-slide-3,
	.section-slider-slide-4 {
		border-radius: 0px;
		position: absolute;
	}

	.slide-logo {
		height: 25px;
		left: -5px;
		margin: auto;
		right: 0px;
		top: 168px;
		width: 132px;
		z-index: 1;
		
		@media (min-width: 936px) {
			// height: 28px;
			height: auto;
			max-height: 50px;
			max-width: 148px;
			top: 189px;
			// width: 148px;
			width: auto;
		}
	}

	.slide-background {
		left: 11px;
		height: 91.1%;
		top: 13px;
		width: 91%;

		@media (min-width: 936px) {
			left: 13px;
			top: 15px;
		}
	}

	.section-slider-slide-1 {
		height: 126px;
		left: -5px;
		margin: auto;
		right: 0;
		top: 254px;
		width: 209px;
		z-index: 1;

		@media (min-width: 936px) {
			height: 141px;
			top: 285px;
			width: 235px;
		}
	}

	.section-slider-slide-2,
	.section-slider-slide-3,
	.section-slider-slide-4 {
		height: 91%;
		left: 12px;
		top: 14px;
		width: 91%;

		@media (min-width: 936px) {
			left: 13px;
			top: 16px;
		}
	}

	.section-slide-container {
		margin: auto;
		position: relative;
		width: fit-content;
		width: -moz-fit-content;
	}

	.loader {
		align-items: center;
		background: rgba(0, 0, 0, .3);
		border-radius: 8px;
		display: flex;
		height: 100%;
		justify-content: center;
		position: absolute;
		top: 1px;
		width: 100%;
		z-index: 100;
	}

	.btn-see-customers {
		border-radius: 100%;
		box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.13) !important;
		height: 54px !important;
		width: 54px !important;
	}

	.btn-customers {
		position: absolute;
		right: 18px;
		top: 20px;
		z-index: 200;
	}

	.bar-title {
		align-items: center;
		background: color(title-green);
		border-radius: 5px;
		display: flex;
		color: color(white);
		font-family: font(lato-regular);
		font-size: size(medium20);
		font-weight: weight(w900);
		height: 57px;
		justify-content: center;
		margin: 10px auto 0px;
		max-width: 90%;
		position: relative;

		&-btn {
			bottom: 0;
			margin: auto;
			position: absolute;
			right: 10px;
			top: 0;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/generate-app/section-phone.vue